import { useEffect, useState } from "react"

export const useIntersectionObserver = (
  element: Element | null,
  options: IntersectionObserverInit = {}
): [isObserved: boolean] => {
  const [isObserved, setIsObserved] = useState(false)

  useEffect(() => {
    const onObserve: IntersectionObserverCallback = entries => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          setIsObserved(true)
          return
        }
      }
    }

    const observer = new IntersectionObserver(onObserve, options)

    if (element) {
      observer.observe(element)
    }

    return () => {
      if (element) {
        observer.unobserve(element)
      }
    }
  }, [element, options])

  return [isObserved]
}
